import React, { useEffect, useRef } from 'react';
import BranchSummary from './BranchSummary';
import ServiceNavigation from './ServiceNavigation';
import { Button, Empty, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import styles from './index.less';
import { F } from '@/utils/intl';
import { CheckAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';
import { BranchModel } from '@/typings/models/Location';

interface LeftPanelProps {
  branch: BranchModel;
  selectedNavItem: string;
  onSelectNavItem: (item: string | number) => void;
  onAddService: () => void;
}

const LeftPanel: React.FC<LeftPanelProps> = ({
  branch,
  selectedNavItem,
  onSelectNavItem,
  onAddService,
}) => {
  const navSectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (navSectionRef.current) {
      navSectionRef.current.scrollTo(0, 0);
    }
  }, [branch?.id]);

  if (branch.id === 'NEW') return null

  const services = branch?.services || branch?.branch_services || [];
  const branchServices = services.filter(service => !service.deleted_at);

  return (
    <div className={styles.leftPanel}>
      <BranchSummary branch={branch} />
      {branchServices.length > 0 ? (
        <>
          <div ref={navSectionRef} className={styles.navSection}>
            <ServiceNavigation
              branch={branch}
              services={branchServices}
              selectedServiceId={selectedNavItem}
              onSelectService={(id) => onSelectNavItem(id)}
            />
          </div>
          <Button
            color={'primary'}
            variant={'outlined'}
            icon={<PlusOutlined />}
            onClick={onAddService}
            className={styles.addServiceBtn}
          >
            <F id={'entity.service.singular'} />
          </Button>
        </>
      ) : (
        <Empty
          style={{ margin: '40px 20px' }}
          description={
            <div>
              <Typography.Text>
                <F
                  id="pages.locations.serviceTypes.emptyDescription"
                  defaultMessage="No service types are available."
                />
              </Typography.Text>
              <CheckAccess
                access={[
                  PERMISSIONS.ServiceType.CREATE,
                  PERMISSIONS.BUSINESS_PARTNER,
                ]}
              >
                <div style={{ marginTop: 16 }}>
                  <Button
                    onClick={onAddService}
                    icon={<PlusOutlined />}
                    variant={'outlined'}
                    color={'primary'}
                    size={'small'}
                  >
                    <F id={'entity.service.singular'} />
                  </Button>
                </div>
              </CheckAccess>
            </div>
          }
        />
      )}
    </div>
  );
};

export default LeftPanel;
